import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/solution/neirong.png'
import _imports_1 from '@/assets/images/solution/jishu.png'
import _imports_2 from '@/assets/images/solution/fuwu.png'


const _hoisted_1 = { class: "education" }
const _hoisted_2 = { class: "fays" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "yycj" }
const _hoisted_5 = { class: "yycj-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "title" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "jiaoyu" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "title" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "yyal" }
const _hoisted_17 = { class: "yyal-content" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "detail" }
const _hoisted_23 = { class: "pagination" }
const _hoisted_24 = ["onClick"]

import { ref, onMounted, computed } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
const pageSize = 5


export default /*@__PURE__*/_defineComponent({
  __name: 'EducationModel',
  setup(__props) {

const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesListAll: any = ref([])
const currentPage = ref(1)
const toOtherPath = (url: string, pageTitle: any) => {
  router.push(url);
  store.state.pageTitle = [...pageTitle]
}

const totalPages = computed(() => Math.ceil(casesListAll.value.length / pageSize))
const paginatedCases = computed(() => {
  const start = (currentPage.value - 1) * pageSize
  return casesListAll.value.slice(start, start + pageSize)
})

const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++
}

const goToPage = (page: number) => {
  currentPage.value = page
}

onMounted(async () => {
  // 条件判断：只有当数据为空时才请求接口
  // 因为父组件被 keep-alive 缓存，子组件也会被缓存
  // 再次进入页面时 onMounted 仍会执行，但数据已经存在，不需要重新请求
  if (casesListAll.value.length === 0) {
    selectCommonElement({ columnId: 4 }).then((res: any) => {
      casesListAll.value = [...res].filter(e => e.industry == 3).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0)) || []
      currentPage.value = 1
    })
  }

  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.yycj_img5) {
    const yycj_img5: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img5.png');
    const yycj_icon5: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-icon5.png');
    const yycj_icon6: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-icon6.png');
    const yycj_img6: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img6.png');
    const yycj_img7: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img7.png');
    const yycj_icon7: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-icon7.png');
    const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
    loadUrl.value = { yycj_img5, yycj_icon5, yycj_icon6, yycj_img6, yycj_img7, yycj_icon7, fays_bg }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"title-font-style\" data-v-39a944fb>教育解决方案</div><div class=\"illustrate\" data-v-39a944fb><div data-v-39a944fb>针对教育行业课程创建教学场景和虚拟仿真课件，实现教学内容的场景化和教学质量的闭环管理，突出互动性和趣味性，达到高效、有趣、安全的教学效果。</div></div><div class=\"subtitle\" data-v-39a944fb>行业痛点</div><div data-v-39a944fb><div class=\"disadvantage\" data-v-39a944fb>数实结合的沉浸式教学体验可以实现对传统教学方式的变革，为教育行业带来全新的体验和机会。</div></div><div class=\"subtitle\" data-v-39a944fb>方案优势</div>", 5)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.fays_bg
      }, null, 8, _hoisted_3),
      _cache[0] || (_cache[0] = _createStaticVNode("<div data-v-39a944fb><div data-v-39a944fb><img src=\"" + _imports_0 + "\" data-v-39a944fb><div class=\"title\" data-v-39a944fb>内容优势</div><div data-v-39a944fb>XR可视化培训相比传统方式，更为直观易学，有效缩短员工培训时间，提高培训效率。</div></div><div data-v-39a944fb><img src=\"" + _imports_1 + "\" data-v-39a944fb><div class=\"title\" data-v-39a944fb>技术优势</div><div data-v-39a944fb>以互动性+趣味性打造XR虚拟仿真教学平台，实现课程“教-学-练-考”的闭环课程体系。</div></div><div data-v-39a944fb><img src=\"" + _imports_2 + "\" data-v-39a944fb><div class=\"title\" data-v-39a944fb>服务优势</div><div data-v-39a944fb>提供内容+设备+软件定制化安装服务，7x24全天候技术服务支持。</div></div></div>", 1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "subtitle" }, "应用场景", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img5,
            class: "left-radius"
          }, null, 8, _hoisted_6),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: loadUrl.value.yycj_icon5
              }, null, 8, _hoisted_8),
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "中小学教育", -1))
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "content" }, "打造虚实结合的沉浸式教学体验，提供更加直观和身临其境的学习环境，提升教学质量。", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: loadUrl.value.yycj_icon6,
                class: "right-radius"
              }, null, 8, _hoisted_11),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "职业教育培训", -1))
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "content" }, "通过VR/AR技术进入高度逼真的三维虚拟世界里，进行虚拟实训、虚拟学习等，在虚拟环境中接受到更加系统化、全面化的培训。", -1))
          ]),
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img6
          }, null, 8, _hoisted_12)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img7,
            class: "left-radius"
          }, null, 8, _hoisted_13),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("img", {
                src: loadUrl.value.yycj_icon7
              }, null, 8, _hoisted_15),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "高等院校实验室", -1))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "content" }, "建设元宇宙虚拟实验室，以大数据、人工智能等技术为支撑，与教育教学环境深度融合创新。", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "subtitle" }, "应用案例", -1)),
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedCases.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (toOtherPath(`/case_detail?id=${item.id}&pathName=解决方案,教育解决方案,应用案例`, ['解决方案', '教育解决方案', '应用案例']))
          }, [
            _createElementVNode("img", {
              src: item.ossPath
            }, null, 8, _hoisted_19),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(item.title), 1),
              _createElementVNode("div", null, _toDisplayString(item.subTitle), 1),
              _createElementVNode("div", _hoisted_22, _toDisplayString(item.introduction), 1)
            ])
          ], 8, _hoisted_18))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", {
          class: "prev",
          onClick: prevPage
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (p) => {
          return (_openBlock(), _createElementBlock("div", {
            key: p,
            class: _normalizeClass(currentPage.value === p ? 'active' : ''),
            onClick: ($event: any) => (goToPage(p))
          }, _toDisplayString(p), 11, _hoisted_24))
        }), 128)),
        _createElementVNode("div", {
          class: "next",
          onClick: nextPage
        })
      ])
    ])
  ]))
}
}

})